export enum LocalStorage {
  LAST_TIME_SHOWN_UNCOMPLETED_FIELDS_DIALOG = 'lastTimeShownUncompletedFieldsDialog',
  DASHBOARD_LAYOUT = 'dashboardLayout',
  DASHBOARD_LIST_ORDER = 'dashboardListOrder',
  DASHBOARD_LIST_VISIBILITY = 'dashboardListVisibility',
  JOB_MATCHING_VISIBILITY = 'jobMatchingVisibility',
  JOB_MATCHING_ORDER = 'jobMatchingOrder',
  RESUME_CHECKER_ANALIZE_ID = 'resumeCheckerAnalyzeId',
}
